/* eslint-disable no-restricted-globals */

/**
 * Calculate chance of visibility
 *
 * @param {number} minimum The lowest number in the chance calculation.
 * @param {number} maximum The highest number in the chance calculation.
 */
const getRandomInt = (minimum, maximum) => {
	const min = Math.ceil(minimum);
	const max = Math.floor(maximum) + 1;
	return Math.floor(Math.random() * (max - min) + min);
};

window.addEventListener('DOMContentLoaded', () => {
	// Check if user has reduced motion activated
	const isReduced =
		window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
		window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;

	// Get the do not push button
	const doNotPushButton = document.querySelector('.wp-block-mavis-do-not-push');

	// Get new blocks container
	const wpBlocksContainer = document.querySelector('.wp-site-blocks');

	// If reduced motion is active, stop here
	if (isReduced || !doNotPushButton || !wpBlocksContainer) {
		return;
	}

	// Get page height
	const pageHeight = document.documentElement.getBoundingClientRect().height;
	// Calculate 30% into the page
	const viewStart = (pageHeight / 100) * 30;
	// Calculate 40% from button appearance
	const viewStop = (pageHeight / 100) * 70;
	// Get body element to move button position and add class
	const body = document.querySelector('body');
	// Calculate scroll distance from page top
	const lastScrollTop = window.scrollY || document.documentElement.scrollTop;
	// Check for already stored removed button
	const checkIfRemoved = window.localStorage.getItem('MAVIS_REMOVE_MISCHIEF_BUTTON');
	// Variable to stop function from running when true
	let fired = false;
	// Variable to know to show button if true
	const showOnScroll = !!getRandomInt(0, 1);
	if (showOnScroll) {
		// Add class so css is only applied when button is shown
		body.classList.add('has-dnp');
	}
	let shouldSendAppearInteraction = true;
	let shouldSendClickInteraction = true;

	/**
	 * Set localStorage when a user decides to skip
	 */
	const listenForSkips = () => {
		// Check for already stored removed button
		const isRemoved = JSON.parse(window.localStorage.getItem('MAVIS_REMOVE_MISCHIEF_BUTTON'));

		// If button has not been removed yet store to localStorage
		if (isRemoved === null) {
			window.localStorage.setItem('MAVIS_REMOVE_MISCHIEF_BUTTON', JSON.stringify('removed'));
			doNotPushButton.remove();
			if (window.dataLayer) {
				// Push interaction to GA.
				window.dataLayer.push({
					event: 'mischiefInteraction',
					mischiefInteraction: 'dismiss',
					mischiefType: "Don't click this button",
				});
			}
		}
	};

	/**
	 * Determines whether to show or hide the button
	 *
	 */
	const showHideButton = () => {
		if (scrollY >= viewStart && scrollY <= viewStop) {
			doNotPushButton.classList.add('is-active');
			if (window.dataLayer && shouldSendAppearInteraction) {
				// Push interaction to GA.
				window.dataLayer.push({
					event: 'mischiefAppear',
					mischiefType: "Don't click this button",
				});
				shouldSendAppearInteraction = false;
			}
		}

		// If outside the display point, hide the button
		if (scrollY < viewStart || scrollY > viewStop) {
			doNotPushButton.classList.remove('is-active');
		}
	};

	// Move the button from `wp-site-blocks` to `body` so it remains fixed in position when the site rotates.
	body.appendChild(doNotPushButton);

	// If button has been removed, do not display on page load
	if (checkIfRemoved) {
		doNotPushButton.remove();
	}

	// Add event listeners for the button and the remover
	['mousedown', 'touchstart'].forEach((listener) => {
		doNotPushButton.addEventListener(listener, (e) => {
			// If event type is mousedown, check that it is not a right click
			if (e.type === 'mousedown' && e.which !== 1) {
				return;
			}

			// If click is on remover
			if (e.target.nodeName === 'BUTTON') {
				// Remove button element
				listenForSkips();
			} else {
				// Otherwise, add class that adds transform
				wpBlocksContainer.classList.add('is-rotating');
				doNotPushButton.classList.add('is-pressed');

				if (window.dataLayer && shouldSendClickInteraction) {
					// Push interaction to GA.
					window.dataLayer.push({
						event: 'mischiefInteraction',
						mischiefInteraction: 'click',
						mischiefType: "Don't click this button",
					});
					shouldSendClickInteraction = false;
				}
			}

			// Prevent default behaviour on long press for the button
			e.preventDefault();
		});
	});

	// Add event listener to body to revert the transform
	['mouseup', 'touchend'].forEach((listener) => {
		window.addEventListener(listener, () => {
			wpBlocksContainer.classList.remove('is-rotating');
			doNotPushButton.classList.remove('is-pressed');
		});
	});

	// Add event listener for scrolling into view
	window.addEventListener('scroll', () => {
		const scrollTopPosition = window.scrollY || document.documentElement.scrollTop;

		// If scrolling down and within the display area run function
		if (scrollTopPosition > lastScrollTop && scrollY >= viewStart && fired === false) {
			fired = true;
		}

		// If showOnScroll is true, display the button between start and stop points
		if (showOnScroll) {
			showHideButton();
		}
	});
});
